import React from 'react';
import { formatMoney } from '@shopify/theme-currency';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import { styles } from './CartActions.css';
import { trackCheckoutTriggered } from '@jbhi-fi/utils/src/ga4Tracking/functions/trackCheckoutTriggered';

const onClick = (variant: string) => {
  trackCheckoutTriggered({
    triggerSource: variant === 'cart' ? 'my_cart' : 'mini_cart',
  });
  window.location.href = '/checkout';
};

const TotalRow = ({
  label,
  value,
  customStyle = '',
  testIdPrefix = '',
}: {
  label: string;
  value: string;
  customStyle?: string;
  testIdPrefix?: string;
}) => (
  <div className={`${styles.totals} ${customStyle}`}>
    <div data-testid={`${testIdPrefix}-label`}>{label}</div>
    <div data-testid={`${testIdPrefix}-price`}>{value}</div>
  </div>
);

interface CartActionsProps {
  totalPrice: number;
  totalDiscount: number;
  isFixed?: boolean;
  shouldHide?: boolean;
  variant: 'cart' | 'miniCart';
}

export const CartActions = ({ totalPrice = 0, totalDiscount = 0, isFixed, shouldHide, variant }: CartActionsProps) => {
  return (
    <div className={styles.cartActions({ isFixed, shouldHide })}>
      {totalDiscount ? (
        <TotalRow
          label="Discount"
          value={`-${formatMoney(totalDiscount, window.theme.moneyFormat)}`}
          customStyle={styles.discounts}
          testIdPrefix={`${variant}-discount`}
        />
      ) : null}
      <TotalRow
        label="Subtotal"
        value={formatMoney(totalPrice, window.theme.moneyFormat)}
        testIdPrefix={`${variant}-subtotal`}
      />
      <div className={styles.shipping} data-testid={`${variant}-gst-label`}>
        Includes GST. Shipping calculated at checkout.
      </div>
      <div className={styles.checkoutButtonSection}>
        {variant === 'miniCart' ? (
          <Button
            type="primary"
            label="View cart"
            onClick={() => (window.location.href = '/cart')}
            fullWidth
            data-testid={`${variant}-view-cart`}
          />
        ) : null}
        <Button
          type="action"
          label="Checkout"
          onClick={() => onClick(variant)}
          fullWidth
          data-testid={`${variant}-checkout`}
        />
      </div>
    </div>
  );
};
